<template>
  <div class="block">
    <h3 v-if="title">
      {{ title }}
    </h3>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  box-sizing: border-box;
  width: 375px;
  margin-top: 8px;
  padding: 11px 15px;
  background-color: $color-bg-white;
  h3 {
    padding: 4px 0;
    color: $color-text;
    font-weight: normal;
    font-size: $span-font-size;
    line-height: 20px;
  }
}
</style>
